import { render, staticRenderFns } from "./Modal.Template.Action.Send.vue?vue&type=template&id=0575adec&scoped=true&"
import script from "./Modal.Template.Action.Send.vue?vue&type=script&lang=js&"
export * from "./Modal.Template.Action.Send.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0575adec",
  null
  
)

export default component.exports